import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import Routes from "./app/routes";
import { WINDOW_ON_LOAD, isAppleSafari } from "./utils";
import { HubspotProvider } from "@aaronhayes/react-use-hubspot-form";
import Fonts from "./app/CommonComponents/Fonts";
import Toasters from "./app/CommonComponents/Toaster";


export default function App({ store, basename }) {

  const [font, setFont] = useState(0);

  useEffect(() => {
    const isSafari = isAppleSafari();
    setTimeout(() => {
      setFont(1)
    }, 5000);

    WINDOW_ON_LOAD();

    if (isSafari) { window.addEventListener('storage', readAuthenticationCode); }

    return () => {
      window.removeEventListener('storage', readAuthenticationCode);
    }
  }, [])

  const readAuthenticationCode = (event) => {
    console.log("storage change event");
    if (event.key == 'authCodeSafari') {
      // Handle the message when it changes in localStorage for safari twitter codesdd
      console.log('Received message:', event.newValue);
      localStorage.removeItem('authCodeSafari');
      window.postMessage(event.newValue);
    }
  }

  return (
    <Provider store={store}>
      <React.Suspense>
        <BrowserRouter basename={basename} >
          <HubspotProvider>
            {font ? <Fonts /> : null}
            <Routes />
            <Toasters />
          </HubspotProvider>
        </BrowserRouter>
      </React.Suspense>
    </Provider>
  );
}
